import { PermissionsResourceType } from '@stamhoofd/types/PermissionsResourceType';
import { PermissionLevel } from '@stamhoofd/types/PermissionLevel';
export function getPermissionLevelNumber(level) {
    switch (level) {
        case PermissionLevel.None: return 0;
        case PermissionLevel.Read: return 1;
        case PermissionLevel.Write: return 2;
        case PermissionLevel.Full: return 3;
        default: {
            const l = level; // will throw compile error if new levels are added without editing this method
            throw new Error('Unknown permission level ' + l);
        }
    }
}
export function maximumPermissionlevel(...levels) {
    let max = PermissionLevel.None;
    for (const level of levels) {
        if (getPermissionLevelNumber(level) > getPermissionLevelNumber(max)) {
            max = level;
        }
    }
    return max;
}
export function minimumPermissionLevel(...levels) {
    let min = levels[0];
    for (const level of levels) {
        if (getPermissionLevelNumber(level) < getPermissionLevelNumber(min)) {
            min = level;
        }
    }
    return min;
}
export function getPermissionLevelName(level, resourceType = 'base') {
    if (resourceType === PermissionsResourceType.Senders) {
        switch (level) {
            case PermissionLevel.Read: return $t(`%1DG`);
            case PermissionLevel.Write: return $t(`%1DH`);
        }
    }
    if (resourceType === 'base') {
        switch (level) {
            case PermissionLevel.None: return $t('%1FW');
            case PermissionLevel.Read: return $t('%1eW');
            case PermissionLevel.Write: return $t('%1eL');
            case PermissionLevel.Full: return $t('%Z1');
        }
    }
    switch (level) {
        case PermissionLevel.None: return $t(`%n0`);
        case PermissionLevel.Read: return $t(`%jO`);
        case PermissionLevel.Write: return $t(`%f9`);
        case PermissionLevel.Full: return $t(`%Z1`);
        default: {
            const l = level; // will throw compile error if new levels are added without editing this method
            throw new Error('Unknown permission level ' + l);
        }
    }
}
//# sourceMappingURL=PermissionLevel.js.map